import type { SVGProps } from 'react';

const SvgGasSad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M54.7879 17.5455L54.8182 17.5152L44.2526 6.94955C43.862 6.55903 43.2289 6.55903 42.8383 6.94955L41.0404 8.74746C40.6499 9.13798 40.6499 9.77115 41.0404 10.1617L46.7273 15.8485C43.8788 16.9394 41.8485 19.6667 41.8485 22.9091C41.8485 27.0909 45.2424 30.4849 49.4242 30.4849C50.5152 30.4849 51.5152 30.2424 52.4545 29.8485V51.697C52.4545 53.3637 51.0909 54.7273 49.4242 54.7273C47.7576 54.7273 46.3939 53.3637 46.3939 51.697V38.0606C46.3939 34.7273 43.6667 32 40.3333 32H37.303V10.7879C37.303 7.45457 34.5758 4.72729 31.2424 4.72729H13.0606C9.72727 4.72729 7 7.45457 7 10.7879V59.2728H37.303V36.5455H41.8485V51.697C41.8485 55.8788 45.2424 59.2728 49.4242 59.2728C53.6061 59.2728 57 55.8788 57 51.697V22.9091C57 20.8182 56.1515 18.9091 54.7879 17.5455ZM49.4242 25.9394C47.7576 25.9394 46.3939 24.5758 46.3939 22.9091C46.3939 21.2424 47.7576 19.8788 49.4242 19.8788C51.0909 19.8788 52.4545 21.2424 52.4545 22.9091C52.4545 24.5758 51.0909 25.9394 49.4242 25.9394Z"
      fill="currentColor"
    />
    <rect x="9" y="7" width="26" height="19" rx="4" fill="white" />
    <circle cx="16.2727" cy="14.2727" r="1.77273" fill="currentColor" stroke="currentColor" />
    <circle cx="27.6365" cy="14.2727" r="1.77273" fill="currentColor" stroke="currentColor" />
    <path
      d="M25 21V21C25 19.8954 24.1046 19 23 19L21 19C19.8954 19 19 19.8954 19 21V21"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
);

export default SvgGasSad;
